module.exports = __webpack_public_path__ + "static/media/amazon.a913f00b.svg";